module.exports = __webpack_public_path__ + "81a96d343f12d652cd0c14682aaa43f0.css";